import React from "react";

import { useTranslation } from "react-i18next";

import { userFormattedName } from "@/models/UserModel.ts";
import { SelectItem } from "@/uiKit/atoms/inputs/SelectItem.tsx";
import { FormSelectInput } from "@/uiKit/molecules/form/FormSelectInput.tsx";

type DoctorInfo = {
  id: string;
  firstName: string;
  lastName: string;
};

export type DoctorSelectFormFieldProps = {
  doctors: DoctorInfo[];
  name?: string;
  className?: string;
};

export const DoctorSelectFormField: React.FC<DoctorSelectFormFieldProps> = ({
  doctors,
  name = "doctorId",
  className,
}) => {
  const { t } = useTranslation();
  return (
    <FormSelectInput
      id="doctor-select-form-field"
      name={name}
      label={t("nurseInclusion.doctorSelect")}
      fullWidth
      reserveErrorSpace
      className={className}
    >
      {doctors.map(doctor => (
        <SelectItem key={doctor.id} value={doctor.id}>
          {userFormattedName(doctor.firstName, doctor.lastName)}
        </SelectItem>
      ))}
    </FormSelectInput>
  );
};
